/**
 * PURPOSE: Presentación de nombres de personas que trae la integración SISDEU (FTR-0052): "GUILLERMO NICOLÁS HERRERA" →
 *   "Guillermo Nicolás Herrera".
 * RESPONSIBILITIES: Solo para MOSTRAR; nunca se guarda ni se envía el resultado. Cada palabra: primera letra en
 *   mayúscula y el resto en minúscula, con la Unicode correcta (á é í ó ú ñ ü, Á É Í Ó Ú Ñ Ü, letras fuera del BMP).
 *   Espacios múltiples o de los extremos colapsados; el guion y el apóstrofo (recto o tipográfico) inician una palabra
 *   ("María-José", "O'Higgins"). Texto en NFC para que una vocal con tilde combinada se muestre como una sola letra.
 *   No repara texto con mojibake (eso se corrige en el origen) ni toca nombres que no vengan de SISDEU: lo usan solo las
 *   pantallas de la integración.
 * COLLABORATORS: area/InstitucionesArea/SisdeuImportPanel.jsx, area/InstitucionesArea/ImportAccreditationsModal.jsx,
 *   area/CategoriasIndividualArea/CategoriasIndividualArea.jsx.
 * ROUTE: winscore/src/utils/sisdeuName.js
 */
const WORD_BOUNDARY = /(\s+|[-'’])/u;

const capitalize = (word) => {
  const [first = "", ...rest] = Array.from(word.toLowerCase());
  return first.toUpperCase() + rest.join("");
};

/** Nombre para mostrar; valores no textuales o vacíos dan "". */
export const formatSisdeuName = (value) => {
  if (typeof value !== "string") return "";
  return value
    .normalize("NFC")
    .trim()
    .split(WORD_BOUNDARY)
    .map((part) => (/^\s+$/u.test(part) ? " " : /^[-'’]$/u.test(part) ? part : capitalize(part)))
    .join("");
};

export default formatSisdeuName;
